import {
  Box,
  Button,
  Card,
  Dialog,
  DialogTitle,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import AddNewTeach from './AddNewTeach';
import { ITeachScreen } from '../../../../../@types/teachscreen.type';
import { fDate, fDateTime } from '../../../../../utils/formatTime';

type Props = {
  clinicalRecordId: number;
  teachScreen: ITeachScreen;
  showCLForm: boolean;
  getTeachScreenRecords: (teachScreenId: number, clinicalId: number) => void;
  onUpdate?: () => Promise<any> | void;
};

const Teach = ({
  clinicalRecordId,
  teachScreen,
  showCLForm,
  getTeachScreenRecords,
  onUpdate,
}: Props) => {
  const [openModal, setOpenModal] = useState(false);
  const handleClick = () => {
    setOpenModal(true);
  };

  const hasTeachScreen = !!teachScreen && Object.keys(teachScreen).length > 0;

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  return (
    <>
      {(showCLForm || !hasTeachScreen) && (
        <Typography sx={{ ml: 1, mt: 2, mb: 2 }} color={'red'}>
          * There's no Teach Screen added for this clinical record, please add
          and save!
        </Typography>
      )}
      <Box
        sx={{
          margin: 2,
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
        }}
      >
        <Typography variant="h6">Teach</Typography>
        {/* The `!teachScreen || (… && <Button/>)` form rendered the boolean
            `true` (so nothing) whenever there was no record at all. */}
        {!hasTeachScreen && (
          <Button data-lock-hide onClick={handleClick}>
            Add New Teach
          </Button>
        )}
      </Box>

      {hasTeachScreen && (
        <Card sx={{ margin: '1% 2%', cursor: 'pointer' }} onClick={handleClick}>
          {/* `formatDate` from @fullcalendar/core was called without any format
              options and returned an empty string for a missing value, so the
              card showed no date (client bug 43). The app's own date helpers
              are used instead. */}
          <Typography
            variant="h6"
            sx={{ display: 'flex', justifyContent: 'center' }}
          >
            {fDateTime(teachScreen?.createdDate)}
          </Typography>
          <Typography
            sx={{ color: 'text.secondary', marginTop: 1, marginLeft: 2 }}
          >
            <strong>Teach By:</strong> {teachScreen?.teachBy || '—'}
          </Typography>
          <Typography
            sx={{ color: 'text.secondary', marginTop: 1, marginLeft: 2 }}
          >
            <strong>Date:</strong> {fDate(teachScreen?.date) || '—'}
          </Typography>
        </Card>
      )}

      <Dialog
        fullWidth
        maxWidth="md"
        open={openModal}
        onClose={handleCloseModal}
      >
        <DialogTitle>
          {hasTeachScreen ? 'View Teach' : 'Add New Teach'}
        </DialogTitle>
        <AddNewTeach
          clinicalRecordId={clinicalRecordId}
          setOpenModal={(openModal: boolean) => setOpenModal(openModal)}
          getTeachScreenRecords={getTeachScreenRecords}
          teachScreen={teachScreen}
          showCLForm={showCLForm}
          onUpdate={onUpdate}
        />
      </Dialog>
    </>
  );
};

export default Teach;
